import { useEnvironmentContext } from '@openeducation/oe-it-providers';
import { useQuery } from 'react-query';

import { KeepAliveService } from '../services/keep-alive.service';

const INTERVAL_TIME = 300000;

export function useServerTime() {
  const { environment } = useEnvironmentContext();

  const { data } = useQuery(
    ['ServerTime', environment],
    () => KeepAliveService.getServerTime(environment),
    { refetchInterval: INTERVAL_TIME }
  );
  return { data };
}
